import { bff, toClientError } from './bff'

const run = (p) => p.then((r) => r.data).catch((e) => Promise.reject(toClientError(e)))

// F1 — RSS/Atom feed subscriptions (audio episodes → transcribe saga; text
// articles → indexed with provenance).
export const listFeeds = () => run(bff.get('/api/feeds'))

export const addFeed = ({ url, project, auto_import }) =>
  run(bff.post('/api/feeds', { url, project, auto_import }, { timeout: 0 }))

export const deleteFeed = (id) => run(bff.delete(`/api/feeds/${id}`))

export const refreshFeed = (id) => run(bff.post(`/api/feeds/${id}/refresh`, {}, { timeout: 0 }))

export const listFeedItems = ({ feedId, limit }) =>
  run(bff.get(`/api/feeds/${feedId}/items`, { params: { limit } }))

export const importFeedItem = ({ itemId, project }) =>
  run(bff.post(`/api/feeds/items/${itemId}/import`, { project }, { timeout: 0 }))
